<i18n src="./resources/locales.json"></i18n>

<template>
  <v-menu
    v-model="open"
    :close-on-click="false"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        ref="input"
        :value="expirationTime"
        :label="label"
        :placeholder="placeholder"
        outlined
        readonly
        hide-details
        append-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        @click:append="onCalendarIconClick"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" :min="getMinDate()" class="datetime-picker" no-title scrollable>
      <div class="datetime-picker-footer">
        <div class="datetime-timer-picker">
          <v-icon left>
            mdi-clock-time-three-outline
          </v-icon>
          <EcsTimePicker
            :clearable="false"
            :disabled="false"
            placeholder=""
            :format="timeFormat"
            :value="time"
            @input="onTimerChange"
            @change="onTimerChange"
          />
        </div>
        <div class="datetime-picker-actions">
          <v-btn text depressed @click="handleCancel">
            <span v-once>{{ $t('cancel') }}</span>
          </v-btn>
          <v-btn text color="primary" @click="handleSave">
            <span v-once>{{ $t('ok') }}</span>
          </v-btn>
        </div>
      </div>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment-timezone';
import EcsTimePicker from '@/components/ecs-time-picker/EcsTimePicker';

export default {
  name: 'EcsDateTimePicker',

  components: { EcsTimePicker },

  props: {
    value: {
      type: String,
      default: moment.utc().toISOString()
    },
    timeFormat: {
      type: String,
      required: true
    },
    timeZone: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      date: null,
      time: null,
      open: false
    };
  },

  computed: {
    dateTimeFormat() {
      return `YYYY-MM-DD ${this.timeFormat}`;
    },

    expirationTime() {
      let result = '';

      if (this.date && this.time) {
        result = `${this.date} ${this.time}`;
      }

      return result;
    }
  },

  watch: {
    value(newValue) {
      this.initializeValues();
    }
  },

  mounted() {
    this.initializeValues();
  },

  methods: {
    getMinDate() {
      return moment
        .utc()
        .utcOffset(this.timeZone)
        .format('YYYY-MM-DD');
    },

    initializeValues() {
      const dateTime = moment.utc(this.value).utcOffset(this.timeZone);
      this.date = dateTime.format('YYYY-MM-DD');
      this.time = dateTime.format(this.timeFormat);
    },

    onTimerChange(value) {
      this.time = value;
    },

    onCalendarIconClick() {
      this.open = true;
      this.$refs.input.focus();
    },

    handleCancel() {
      this.initializeValues();
      this.open = false;
    },

    handleSave() {
      this.open = false;
      this.$emit('change', moment.tz(this.expirationTime, this.dateTimeFormat, this.timeZone).toISOString());
    }
  }
};
</script>

<style lang="scss" scoped>
.datetime-picker {
  & ::v-deep .v-date-picker-table {
    height: 212px !important;
  }

  & ::v-deep .v-picker__body {
    background: var(--v-surface-base);
  }

  & ::v-deep .v-picker__actions {
    padding: 0;
  }
}

.datetime-picker-footer {
  display: grid;
  grid-template-rows: 36px 36px;
  width: 100%;
  background: var(--v-surface-base);

  .datetime-timer-picker {
    display: inline-flex;
    justify-content: center;
    align-self: center;
  }

  .datetime-picker-actions {
    justify-self: end;
  }
}
</style>
